document.addEventListener('DOMContentLoaded', function () {
 const bannerSwipers = document.querySelectorAll('.bnr-swiper');
 if (!bannerSwipers.length) return;

 bannerSwipers.forEach(function (el) {
   new Swiper(el, {
     loop: true,
     loopAdditionalSlides: 3,
     watchSlidesProgress: true,
     slidesPerView: 1.4,
     spaceBetween: 13,
     centeredSlides: true,
     speed: 500,
     grabCursor: true,

     // autoplayなし
     // autoplay: { delay: 4000 },

    //  pagination: {
    //   el: el.querySelector('.swiper-pagination'),
    //   clickable: true,
    // },

     navigation: {
       nextEl: el.querySelector('.swiper-button-next2'),
       prevEl: el.querySelector('.swiper-button-prev2'),
     },

     on: {
       init: function () {
         // このSwiper内だけに限定
         el.querySelectorAll('.swiper_img').forEach(function (img) {
           setTimeout(function () {
             img.style.opacity = 1;
           }, 100);
         });

         setTimeout(function () {
           const nextBtn = el.querySelector('.swiper-button-next2');
           const prevBtn = el.querySelector('.swiper-button-prev2');
           if (nextBtn) nextBtn.style.opacity = 1;
           if (prevBtn) prevBtn.style.opacity = 1;
         }, 300);
       },
     },

     // SP用前提（PCではCSSで非表示にする想定）
     breakpoints: {
       769: {
         slidesPerView: 1,   // 一応安全側（実際はPCで非表示）
         centeredSlides: false,
       },
     },
   });
 });
});
